const fetcher = async (user, eventId: string): Promise<boolean> => {
	const url = window.config.Endpoints.UserEventFollowsByPostId.replace(
		'{eventId}',
		eventId
	);
	url.replace('{email}', user.email);
	const res = await fetch(`${process.env.REACT_APP_GATEWAY_URL}${url}`, {
		method: 'GET',
		headers: {
			Accept: 'application/json',
			Authorization: `bearer ${user?.token}`
		}
	});
	try {
		if (res.ok) {
			return true;
		}
		return false;
	} catch (error) {
		return false;
	}
};

export async function getUserEventFollow(user: any, eventId: string): Promise<boolean> {
	return fetcher(user, eventId);
}
